import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';

import axios from '../../../axios-drops';


import classes from './AdminDropMenu.css';

class adminDropMenu extends Component {

    state = {
        regNum: 0
    }
    componentDidMount() {

        this.loadInfo()
        
    }


    loadInfo = async () => {
        let genCount = 0
        // let winCount = 0
        await axios.get('/registrations/' + this.props.id + '/general.json')
        .then(response => {
            for (let _key in response.data) {
                genCount++
            }
            this.setState({regNum: genCount})
        })

        // await axios.get('/registrations/' + this.props.id + '/winners.json')
        // .then(response => {
        //     // console.log(response.data)
        //     for (let key in response.data) {
        //         for (let _keyA in response.data[key]){
        //             winCount++
        //         }
                
        //     }
        // }) 

        // // console.log(winCount)

        // if (winCount > 0) {
        //     this.setState({regNum: winCount})
        // } else {
        //     // console.log('check')
        //     this.setState({regNum: genCount})
        // }

        
                
    }

    
    
    render () {

       


        return (
    
            <div className={classes.AdminDropMenu}
                onClick={this.props.click}>
                <img
                    className={classes.Image}
                    src={this.props.image}
                    alt="not found"/>
                <div className={classes.TextGroup}>
                    <h3 className={classes.Name}>{this.props.name}</h3>
                    <h3 className={classes.Variant}>{this.props.variant}</h3>
                    <div className={classes.TextGrid}>
                        <p className={classes.Edition}><strong>LE {this.props.edition}</strong></p>
                        <p className={classes.Cost}><strong>Cost: ${this.props.cost}</strong></p>
                    </div>
                    <p className={classes.NumberAvailable}><strong>{this.props.numberAvailable + '/' + this.props.originallyAvailable} Available</strong></p>
                    <p className={classes.Registrations}><strong>Registrations: {this.state.regNum}</strong></p>
                </div>
                
            </div>
        )
    }
}

export default withRouter(adminDropMenu);


// WEBPACK FOOTER //
// ./src/components/UI/AdminDropMenu/AdminDropMenu.js